import { WidgetOutlet } from '@/core/widgets/export';
import PipelineMapTabBar from '@/modules/pipelines/components/deep-dive/pipeline-map-tab-bar';
import styles from '@/modules/pipelines/components/deep-dive/pipeline-map-tabs.module.scss';

export default function PipelineMapLayout() {
  return (
    <div className={styles.panel}>
      <PipelineMapTabBar />
      <div className={styles.content}>
        <WidgetOutlet />
      </div>
    </div>
  );
}
